import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { IllegalGroupAttendance } from "./IllegalGroupAttendance";

export const IllegalReceivedComplaintsFromOfficials = () => {
    const { t } = useTranslation()
    const navigate = useNavigate();
    return (
        <div className="row p-1 m-1 mt-2 " >

            <div className="col-12 col-lg-12 col-xl-9 " >
                <div className="row bg-white rounded_eic my-2" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>

                    <div className="col-12">
                        <div className="row my-3">
                            {/* Received Complaints */}
                            <div className="col-12 col-lg-2">
                            </div>

                            <div className="col-12 col-lg-10 text-end py-1">
                                <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                                    <input type="radio" className="btn-check" name="btnradio4" id="sky1" autocomplete="off" checked />
                                    <label className="btn btn-outline-primary fw-bold" for="sky1">{t('EncroachmentDashboard.Total')}</label>

                                    <input type="radio" className="btn-check" name="btnradio4" id="sky2" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky2">{t('EncroachmentDashboard.ZoneA')}</label>

                                    <input type="radio" className="btn-check" name="btnradio4" id="sky3" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky3 ">{t('EncroachmentDashboard.ZoneB')}</label>

                                    <input type="radio" className="btn-check" name="btnradio4" id="sky4" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky4">{t('EncroachmentDashboard.ZoneC')}</label>

                                    <input type="radio" className="btn-check" name="btnradio4" id="sky5" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky5">{t('EncroachmentDashboard.ZoneD')}</label>

                                    <input type="radio" className="btn-check" name="btnradio4" id="sky6" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky6">{t('EncroachmentDashboard.ZoneE')}</label>

                                    <input type="radio" className="btn-check" name="btnradio4" id="sky7" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky7">{t('EncroachmentDashboard.ZoneF')}</label>

                                    <input type="radio" className="btn-check" name="btnradio4" id="sky8" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky8">{t('EncroachmentDashboard.ZoneG')}</label>

                                    <input type="radio" className="btn-check" name="btnradio4" id="sky9" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky9">{t('EncroachmentDashboard.ZoneH')}</label>
                                </div>
                            </div>

                        </div>

                    </div>



                    <div className="col-12 col-md-12 col-lg-12 pb-4 cursor-pointer"
                        onClick={() => navigate('/ReceivedComplaintIllegalGrid')}
                    >
                        <div className="px-4 pb-2 pt-3 rounded background_style gray_bg_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                            <div className="row">
                                <div className="col-12 d-flex justify-content-between pb-2">
                                    <span className=" text-black fw-bold fs-5">{t('EncroachmentDashboard.ReceivedComplaint')}</span>
                                    <span className="fw-bold text-danger fs-3">100</span>
                                    <img src="./static/assets/img/Received_Complaint.png" style={{ width: '40px' }} alt="" srcset="" />
                                </div>
                             
                                <div className="col-12 col-md-4 col-lg-4">
                                    <div className="px-2 bg-white rounded pt-3 text-center border border-3">
                                        <h6 className=" text-dark">{t('EncroachmentDashboard.SarthiPortal')}</h6>
                                        <h2 className="pt-2 fw-bold text-danger">50</h2>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 col-lg-4">
                                    <div className="px-2 bg-white rounded pt-3 text-center border border-3">
                                        <h6 className=" text-dark">{t('EncroachmentDashboard.SocialMedia')}</h6>
                                        <h2 className="pt-2 fw-bold text-danger">25</h2>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 col-lg-4">
                                    <div className="px-2 bg-white rounded pt-3 text-center border border-3">
                                        <h6 className=" text-dark">{t('EncroachmentDashboard.OfficerVisit')}</h6>
                                        <h2 className="pt-2 fw-bold text-danger">25</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-12 pb-3 cursor-pointer"
                    >
                        <div className="px-4 pb-2 pt-3 rounded background_style2  gray_bg_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                            <div className="row">
                                {/* Acknowledged Complaint */}
                                <div className="col-12 col-md-6 col-lg-6 pb-3 cursor-pointer"
                                    onClick={() => navigate('/AcknowledgedComplaintIllegalGrid')}
                                >
                                    <div className="p-4 bg-white" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', borderRadius: '5px' }} >
                                        <div className="row">
                                            <div className="col-9">
                                                <h6 className=" text-dark">{t('EncroachmentDashboard.AcknowledgedComplaint')}</h6>
                                                <h2 className="pt-2 fw-bold text-danger">80</h2>
                                            </div>
                                            <div className="col-3 d-flex align-items-center justify-content-center ">
                                                <img src="./assets/img/eic_img/Acknowledged_Complaint.png" style={{ width: '40px' }} alt="" srcset="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Forward Complaint */}
                                <div className="col-12 col-md-6 col-lg-6 pb-3 cursor-pointer"
                                    onClick={() => navigate('/ForwardComplaintIllegalGrid')}
                                >
                                    <div className="p-4 bg-white" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', borderRadius: '5px' }} >
                                        <div className="row">
                                            <div className="col-9">
                                                <h6 className="text-dark">{t('EncroachmentDashboard.ForwardComplaint')}</h6>
                                                <h2 className="pt-2 fw-bold text-danger">40</h2>
                                            </div>
                                            <div className="col-3 d-flex align-items-center justify-content-center ">
                                                <img src="./assets/img/eic_img/Forward_Complaint.png" style={{ width: '40px' }} alt="" srcset="" />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>



            {/* Illegal Group Attendance */}
            <IllegalGroupAttendance />


        </div>
    )
}